import { cn } from '@/lib/utils'
import { RadarLoader } from '@/components/ui/RadarLoader'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  fullScreen?: boolean
  className?: string
  label?: string
}

export function LoadingSpinner({
  size = 'md',
  fullScreen = false,
  className,
  label,
}: LoadingSpinnerProps) {
  if (fullScreen) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-aviation-bg">
        <RadarLoader size="lg" label={label || "Loading..."} className={className} />
      </div>
    )
  }

  return (
    <RadarLoader
      size={size}
      label={label}
      className={cn(className)}
    />
  )
}
